(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["site-nav"] && !Shopify.designMode) return;
  try {
    function twlInitMobileBrands() {
  const menu = document.querySelector('#menu');
  const item = menu?.querySelector('.twl-brands-menu-item');
  const link = item?.querySelector('[data-twl-brands-directory]');
  const toggle = item?.querySelector('.twl-brands-menu-toggle');
  const list = item?.querySelector('[data-twl-brands-list]');
  if (!link || !toggle || !list || item.dataset.twlBrandsReady) return;
  item.dataset.twlBrandsReady = 'true';
  list.id = 'TwlMobileBrandsList';
  toggle.setAttribute('aria-controls', list.id);
  toggle.hidden = false;
  const update = open => {
    toggle.setAttribute('aria-expanded', String(open));
    item.classList.toggle('expanded', open);
    list.style.display = open ? 'block' : 'none';
    list.setAttribute('aria-hidden', String(!open));
    list.querySelectorAll('a').forEach(a => { a.tabIndex = open ? 0 : -1; });
  };
  menu.addEventListener('click', event => {
    const target = event.target;
    if (!(target instanceof Element)) return;
    if (target.closest('[data-twl-brands-directory]') === link) {
      event.stopImmediatePropagation();
      return;
    }
    if (target.closest('.twl-brands-menu-toggle') === toggle) {
      event.preventDefault();
      event.stopImmediatePropagation();
      update(toggle.getAttribute('aria-expanded') !== 'true');
    }
  }, true);
  new MutationObserver(() => {
    const open = item.classList.contains('expanded');
    if (toggle.getAttribute('aria-expanded') !== String(open)) update(open);
  }).observe(item, { attributes:true, attributeFilter:['class'] });
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', twlInitMobileBrands);
else twlInitMobileBrands();
document.addEventListener('shopify:section:load', twlInitMobileBrands);
  } catch(e) { console.error(e); }
})();

})();
